"use strict";

(function ($, Drupal, once, drupalSettings) {
  'use strict';

  /** Store DOM selectors */
  var selectors = {
    widget: '#find-dentist-widget',
    table: '#dentist-results-table',
    map: '#viewDiv.map',
    mapButton: '#map-btn',
    viewMapLink: '.view-map',
    summary: '#find-dentist-results-summary'
  };

  /** Store asset paths */
  var paths = {
    sprite: '/themes/custom/insure_kids_now/package/dist/img/sprite.svg',
    marker: '/modules/custom/ikn_custom/images/marker.png'
  };

  /** Read dentist map payload */
  function getMapPayload() {
    drupalSettings.ikn_custom = drupalSettings.ikn_custom || {};
    return drupalSettings.ikn_custom.dentist_map_payload || null;
  }

  /** Normalize map key */
  function normalizeKey(key) {
    return (key || '').toString();
  }

  /** Build map toggle button HTML */
  function buildMapToggleHtml(label, iconId) {
    return "".concat(label, " <svg class=\"usa-icon margin-left-1\" aria-hidden=\"true\"><use href=\"").concat(paths.sprite, "#").concat(iconId, "\"></use></svg>");
  }

  /** Index points by key */
  function pointsIndexByKey(payload) {
    var pointByKey = {};
    if (!payload || !payload.points || !payload.points.length) {
      return pointByKey;
    }
    for (var i = 0; i < payload.points.length; i++) {
      var point = payload.points[i];
      if (!point) {
        continue;
      }
      var key = normalizeKey(point.key);
      if (!key) {
        continue;
      }
      pointByKey[key] = point;
    }
    return pointByKey;
  }

  /** Remove duplicate keys */
  function uniqueKeys(keys) {
    var seen = {};
    var out = [];
    for (var i = 0; i < keys.length; i++) {
      var key = normalizeKey(keys[i]);
      if (!key || seen[key]) {
        continue;
      }
      seen[key] = true;
      out.push(key);
    }
    return out;
  }

  /** Read current page map keys */
  function getCurrentPageMapKeys($table) {
    var keys = [];
    if (!$table || !$table.length) {
      return keys;
    }
    if ($.fn.DataTable && $.fn.DataTable.isDataTable($table)) {
      var dt = $table.DataTable();
      var nodes = dt.rows({
        page: 'current'
      }).nodes();
      $(nodes).find('a.view-map[data-map-key]').each(function () {
        var key = normalizeKey($(this).attr('data-map-key'));
        if (key) {
          keys.push(key);
        }
      });
      return keys;
    }
    $table.find('tbody tr a.view-map[data-map-key]').each(function () {
      var key = normalizeKey($(this).attr('data-map-key'));
      if (key) {
        keys.push(key);
      }
    });
    return keys;
  }

  /** Find feature index by fact ID */
  function findFeatureIndexByFactId(graphics, factId) {
    if (!graphics || !graphics.length || !factId) {
      return 0;
    }
    var target = Number.parseInt(factId, 10);
    if (Number.isNaN(target)) {
      return 0;
    }
    for (var i = 0; i < graphics.length; i++) {
      var graphic = graphics[i];
      var attrs = graphic && graphic.attributes ? graphic.attributes : {};
      if (Number.parseInt(attrs.factId, 10) === target) {
        return i;
      }
    }
    return 0;
  }

  /** Wait for ArcGIS loader */
  function waitForArcgisRequire(cb, tries) {
    tries = tries || 0;
    if (typeof window.require === 'function') {
      cb();
      return;
    }
    setTimeout(function () {
      waitForArcgisRequire(cb, tries + 1);
    }, 50);
  }
  Drupal.behaviors.findDentistMap = {
    /** Attach dentist map behavior */
    attach: function attach(context) {
      once('findDentistMap', selectors.widget, context).forEach(function () {
        var $table = $(selectors.table);
        var $mapContainer = $(selectors.map);
        var $mapToggleButton = $(selectors.mapButton);
        if (!$mapContainer.length || !$mapToggleButton.length) {
          return;
        }
        var mapHideHtml = buildMapToggleHtml('Hide Map', 'expand_less');
        var mapShowHtml = buildMapToggleHtml('Show Map', 'expand_more');
        var tableObject = null;
        if ($table.length && $.fn.DataTable) {
          if ($.fn.DataTable.isDataTable($table)) {
            tableObject = $table.DataTable();
          } else {
            tableObject = $table.DataTable({
              paging: true,
              aSort: false,
              bSort: false,
              bSortable: false,
              ordering: false
            });
          }
        }

        /** Bind map toggle click */
        function bindMapToggle() {
          $(document).off('click.findDentistMapToggle', selectors.mapButton).on('click.findDentistMapToggle', selectors.mapButton, function (e) {
            e.preventDefault();
            if ($mapContainer.hasClass('active')) {
              $mapToggleButton.html(mapShowHtml);
              $mapContainer.removeClass('active');
              $mapToggleButton.attr('aria-expanded', 'false');
              return;
            }
            $mapToggleButton.html(mapHideHtml);
            $mapContainer.addClass('active');
            $mapToggleButton.attr('aria-expanded', 'true');
            $(document).trigger('ikn:dentistMapShown');
            window.dispatchEvent(new Event('resize'));
          });
        }
        bindMapToggle();
        if ($mapContainer.data('esri-initialized') === true) {
          return;
        }
        $mapContainer.data('esri-initialized', true);
        waitForArcgisRequire(function () {
          window.require(['esri/Map', 'esri/views/MapView', 'esri/Graphic', 'esri/widgets/Fullscreen', 'esri/widgets/Expand', 'esri/widgets/BasemapGallery'], function (Map, MapView, Graphic, Fullscreen, Expand, BasemapGallery) {
            var map = new Map({
              basemap: 'streets'
            });
            var view = new MapView({
              container: 'viewDiv',
              map: map,
              zoom: 4,
              center: [-80, 35]
            });
            window.__dentistMapView = view;
            view.ui.add(new Fullscreen({
              view: view
            }), 'top-right');
            var basemapGallery = new BasemapGallery({
              view: view
            });
            view.ui.add(new Expand({
              expandIconClass: 'esri-icon-layer-list',
              view: view,
              content: basemapGallery
            }), 'top-left');
            var markerSymbol = {
              type: 'picture-marker',
              url: paths.marker,
              width: '28px',
              height: '43px'
            };
            var graphicsByKey = {};
            var suppressAutoFit = false;

            /** Clear map markers */
            function clearMarkers() {
              graphicsByKey = {};
              view.graphics.removeAll();
              view.popup.visible = false;
            }

            /** Fit map to visible graphics */
            function fitToCurrentGraphics() {
              var graphics = view.graphics.toArray();
              if (!graphics.length) {
                return;
              }
              if (graphics.length === 1) {
                view.goTo({
                  target: graphics[0].geometry,
                  zoom: 12
                })["catch"](function () {});
                return;
              }
              view.goTo({
                target: graphics
              })["catch"](function () {});
            }

            /** Focus a selected graphic with room for popup above it */
            function focusGraphic(g, zoom) {
              if (!g || !g.geometry) {
                return Promise.resolve();
              }
              zoom = zoom || 15;
              return view.goTo({
                target: g.geometry,
                zoom: zoom
              }, {
                animate: true,
                duration: 450
              }).then(function () {
                var screenPoint = view.toScreen(g.geometry);
                if (!screenPoint) {
                  return;
                }
                var popupOffset = Math.min(220, Math.round(view.height * 0.26));
                var adjustedScreenPoint = {
                  x: screenPoint.x,
                  y: screenPoint.y - popupOffset
                };
                var adjustedMapPoint = view.toMap(adjustedScreenPoint);
                if (!adjustedMapPoint) {
                  return;
                }
                return view.goTo({
                  center: adjustedMapPoint,
                  zoom: zoom
                }, {
                  animate: true,
                  duration: 250
                });
              }).then(function () {
                return view.when();
              })["catch"](function () {});
            }

            /** Add markers from map point */
            function addMarkersFromPoint(pointObj) {
              if (!pointObj) {
                return;
              }
              var lat = Number.parseFloat(pointObj.lat);
              var lng = Number.parseFloat(pointObj.lng);
              if (Number.isNaN(lat) || Number.isNaN(lng)) {
                return;
              }
              var key = normalizeKey(pointObj.key);
              var items = pointObj.popup && pointObj.popup.length ? pointObj.popup : [];
              if (!items.length) {
                return;
              }
              var graphicsList = [];
              for (var i = 0; i < items.length; i++) {
                (function (provider) {
                  var graphic = new Graphic({
                    geometry: {
                      type: 'point',
                      latitude: lat,
                      longitude: lng
                    },
                    symbol: markerSymbol,
                    attributes: {
                      mapKey: key,
                      factId: provider.factId
                    },
                    popupTemplate: {
                      content: function content() {
                        var div = document.createElement('div');
                        div.innerHTML = provider.popupHtml;
                        div.querySelectorAll('use[data-icon]').forEach(function (use) {
                          var icon = use.getAttribute('data-icon');
                          if (icon) {
                            use.setAttribute('href', paths.sprite + '#' + icon);
                          }
                        });
                        // Apply USWDS link class to all links
                        div.querySelectorAll('a').forEach(function (a) {
                          a.classList.add('usa-link');
                        });
                        return div;
                      }
                    }
                  });
                  graphicsList.push(graphic);
                  view.graphics.add(graphic);
                })(items[i]);
              }
              graphicsByKey[key] = graphicsList;
            }

            /** Render markers for current page */
            function renderMarkersForCurrentPage(options) {
              options = options || {};
              var fitToBounds = options.fitToBounds !== false;
              var payload = getMapPayload();
              if (!payload || !payload.points || !payload.points.length) {
                clearMarkers();
                return;
              }
              var pointByKey = pointsIndexByKey(payload);
              $table = $(selectors.table);
              var keys = uniqueKeys(getCurrentPageMapKeys($table));
              clearMarkers();
              for (var i = 0; i < keys.length; i++) {
                var key = normalizeKey(keys[i]);
                var point = pointByKey[key];
                if (!point) {
                  continue;
                }
                addMarkersFromPoint(point);
              }
              if (fitToBounds && !suppressAutoFit) {
                fitToCurrentGraphics();
              }
            }

            /** Ensure map panel is visible */
            function ensureMapVisible() {
              if ($mapContainer.hasClass('active')) {
                return;
              }
              $mapToggleButton.html(mapHideHtml);
              $mapContainer.addClass('active');
              $mapToggleButton.attr('aria-expanded', 'true');
              $(document).trigger('ikn:dentistMapShown');
              window.dispatchEvent(new Event('resize'));
              setTimeout(function () {
                if (view && view.resize) {
                  view.resize();
                }
              }, 150);
            }

            /** Open popup group for markers */
            function openPopupGroup(list, targetGraphic, selectedIndex) {
              if (!list || !list.length || !targetGraphic) {
                return;
              }
              suppressAutoFit = true;
              view.popup.close();
              focusGraphic(targetGraphic, 15).then(function () {
                view.popup.highlightEnabled = false;
                view.popup.alignment = 'top-center';
                view.popup.open({
                  location: targetGraphic.geometry,
                  features: list
                });
                try {
                  view.popup.selectedFeatureIndex = selectedIndex;
                } catch (e) {}
                view.popup.focus();
              })["finally"](function () {
                suppressAutoFit = false;
              });
            }

            /** Bind map refresh events */
            function bindMapRefreshEvents() {
              if (tableObject && tableObject.on) {
                tableObject.on('draw', function () {
                  renderMarkersForCurrentPage();
                });
              }
              $(document).on('ikn:dentistResultsUpdated', function (e, data) {
                if (data && data.map) {
                  drupalSettings.ikn_custom = drupalSettings.ikn_custom || {};
                  drupalSettings.ikn_custom.dentist_map_payload = data.map;
                }
                renderMarkersForCurrentPage();
              });
              $(document).on('ikn:dentistMapShown', function () {
                renderMarkersForCurrentPage();
              });
            }

            /** Bind table view-map links */
            function bindViewMapLinks() {
              $(document).off('click.findDentistViewMap', selectors.viewMapLink).on('click.findDentistViewMap', selectors.viewMapLink, function (e) {
                e.preventDefault();
                var $link = $(this);
                var key = normalizeKey($link.attr('data-map-key'));
                var factId = $link.attr('data-fact-id');
                var lat = $link.attr('data-lat');
                var lng = $link.attr('data-lng');
                ensureMapVisible();
                renderMarkersForCurrentPage({
                  fitToBounds: false
                });
                var list = graphicsByKey[key] || [];
                if (!list.length && lat && lng) {
                  var fLat = Number.parseFloat(lat);
                  var fLng = Number.parseFloat(lng);
                  if (!Number.isNaN(fLat) && !Number.isNaN(fLng)) {
                    view.goTo({
                      center: [fLng, fLat],
                      zoom: 15
                    })["catch"](function () {});
                  }
                  return;
                }
                if (!list.length) {
                  return;
                }
                var selectedIndex = findFeatureIndexByFactId(list, factId);
                var targetGraphic = list[selectedIndex] || list[0];
                openPopupGroup(list, targetGraphic, selectedIndex);
                var $summary = $(selectors.summary);
                if ($summary.length) {
                  $('html, body').animate({
                    scrollTop: $summary.offset().top
                  }, 700);
                }
              });
            }
            view.on('click', function (event) {
              view.hitTest(event).then(function (response) {
                if (!response.results || !response.results.length) {
                  return;
                }
                var graphic = response.results[0].graphic;
                if (!graphic || !graphic.attributes) {
                  return;
                }
                var key = normalizeKey(graphic.attributes.mapKey);
                var list = graphicsByKey[key] || [];
                if (!list.length) {
                  return;
                }
                var selectedIndex = findFeatureIndexByFactId(list, graphic.attributes.factId);
                openPopupGroup(list, graphic, selectedIndex);
              });
            });
            view.when(function () {
              renderMarkersForCurrentPage();
            });
            bindMapRefreshEvents();
            bindViewMapLinks();
          });
        });
      });
    }
  };
})(jQuery, Drupal, once, drupalSettings);